// The layer every hover tooltip portals into. A tooltip only ever shows for
// the control under the pointer, so it sits above every panel, dialog and
// menu that control can live in: the chat console's overlay and the dialogs
// at 10000, the knowledge graph panel at 10002, menus up to 99999.
// tooltipLayer.test.js keeps every other layer under it.
export const TOOLTIP_LAYER = "z-[100000]";
